/**
 * Converts USD dollars to USD cents
 * @param {string} amount formatted amount e.g. $1.00
 * @return {number} amount in cents
 */
export const dollarsToCents = (amount) => {
  return Math.round(
    100 * parseFloat(typeof amount === 'string' ? amount.replace(/[$,]/g, '') : amount)
  )
}

export const docOffset = (el) => {
  let rect = el.getBoundingClientRect()
  let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

export const handleize = str => str.replace(/[ /_]/g, '-').toLowerCase()

/**
 * Decodes a string that has been encode through the 'url_encode' Shopify filter
 *
 * @param {*} str encoded string
 * @returns {string} decoded string
 */
export const decode = str => decodeURIComponent(str).replace(/\+/g, ' ')

export const parts = (src) => {
  const arr = src.split(new RegExp(`.(jpg|jpeg|png|gif)`))

  return {
    originalPath: arr[0],
    filePath: arr[0].replace(new RegExp(`_[0-9]*x`), ''),
    ext: arr[1],
    query: arr[2]
  }
}

export const getSizeSrc = (src, size) => {
  const { filePath, ext, query } = parts(src)
  return `${filePath}_${size}x.${ext + query}`
}
